import { Route } from "react-router-dom";

import { VIEW_TOOL } from "src/constants";
import { TOOLS_ROUTES } from "src/pages/tools/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { SingleTool } from "./SingleTool.page";
import { Tools } from "./Tools.page";

/** Route tree for the tools module, mounted under `/tools`. */
export const toolsRoutes = (
  <>
    <Route path={TOOLS_ROUTES.root} element={<ProtectedRoute permissions={VIEW_TOOL} component={Tools} />} />
    <Route path={TOOLS_ROUTES.details} element={<ProtectedRoute permissions={VIEW_TOOL} component={SingleTool} />} />
  </>
);
